export default {
  custom: {
    "payment amount": {
      min_value: "The minimum payment is $1.00",
      max_value: "The maximum payment is $9,999,999.99",
    },
    "phone number": {
      min: "Complete phone number required.",
    },
    "password confirmation": {
      confirmed: "The password confirmation field must match the password.",
    },
    "account number": {
      length: "The account number must be 10 or 11 characters."
    },
    "termsofuse": {
      required: "You must agree to the terms of use."
    }
  },
}